import { FluxBani } from './cash-flow'

export function Receipts() {
  return <FluxBani directie="income" />
}
